export default interface DivisionItem {
    id: number;
    name: string;
}

export const divisionItemDefaultProps: DivisionItem = {
    id: 0,
    name: ''
}
